import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ROLE_APP } from "constants/actionAccess";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, Form } from "reactstrap";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import * as yup from "yup";
import MessageFormValidate from "../../../../components/shared-components/MessageFormValidate";
import { formValidate } from "../../../../helpers/form_helper";
import {
  useInsertOrderRefCode,
  useUpdateExistOrderRefCode,
} from "../../../../hooks";
import BarcodeScannerButton from "./BarcodeScannerButton/BarcodeScannerButton";

const UpdateRefCodeForm = ({
  orderId,
  refCode,
  isUpdateExist = false,
  onSuccess,
  ...params
}) => {
  const { t } = useTranslation(["order"]);
  const initDefaultValues = {
    code: refCode || "",
  };
  const schema = yup.object().shape({
    code: yup
      .string()
      .required(t("form.validate.required", { title: t("detail.referCode") })),
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting, isDirty },
    setFocus,
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    watch,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });
  const onSuccessInsertOrderRefCode = () => {
    onSuccess?.({
      ref_code: getValues("code"),
    });
  };
  const { mutate: insertOrderRefCode, isLoading: isLoadingInsertOrderRefCode } =
    useInsertOrderRefCode(onSuccessInsertOrderRefCode);
  const {
    mutate: updateExistOrderRefCode,
    isLoading: isLoadingUpdateExistOrderRefCode,
  } = useUpdateExistOrderRefCode(onSuccessInsertOrderRefCode);

  const handleSubmitRefCode = e => {
    trigger();
    handleSubmit(() => {
      if (isUpdateExist) {
        updateExistOrderRefCode({
          id: orderId,
          ref_code: getValues("code"),
        });
      } else {
        insertOrderRefCode({
          id: orderId,
          ref_code: getValues("code"),
        });
      }
    })();
  };

  const [isRoleLogAdmin, setIsRoleLogAdmin] = useState(false);
  const [isRoleHubAdmin, setIsRoleHubAdmin] = useState(false);
  const [allowFocusInput, setAllowFocusInput] = useState(true);

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const listRole = info["auth"].split(",");
    setIsRoleLogAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_LOG_ADMIN)) || false
    );
    setIsRoleHubAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_HUB_ADMIN)) || false
    );
  }, []);

  useEffect(() => {
    let intervalId = null;
    if (allowFocusInput) {
      intervalId = setInterval(() => {
        setFocus("code", { shouldSelect: true });
      }, 500);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [allowFocusInput]);

  const handleKeyDown = event => {
    if (event.key.toLowerCase() === "enter") {
      event.preventDefault();
      handleSubmitRefCode();
    } else {
      setAllowFocusInput(false);
    }
  };

  return (
    <Form>
      <div>
        <div
          className="d-flex"
          style={{ alignItems: "center" }}
          onBlur={() => {
            setAllowFocusInput(true);
          }}
        >
          <input
            type="search"
            autoComplete="off"
            onKeyDown={handleKeyDown}
            style={{ position: "relative" }}
            className={`form-control ${formValidate(
              errors,
              touchedFields,
              "code"
            )}`}
            placeholder={t("detail.referCode")}
            {...register("code")}
          />
          <BarcodeScannerButton
            handleResult={data => {
              setValue("code", data);
            }}
          />
        </div>
        {errors.code && <MessageFormValidate error={errors.code.message} />}
      </div>
      <div className="text-end mt-2">
        <Button
          disabled={
            isUpdateExist
              ? isLoadingUpdateExistOrderRefCode
              : isLoadingInsertOrderRefCode
          }
          color="primary"
          onClick={handleSubmitRefCode}
        >
          {t("button.update_refcode")}
        </Button>
      </div>
    </Form>
  );
};

export default UpdateRefCodeForm;
